import { FleetFields } from '../FleetFields';

import type { FleetWizardData } from './types';

interface Props {
  fleet: FleetWizardData;
  onFleet: (partial: Partial<FleetWizardData>) => void;
}

export function Step4FleetSettings({ fleet, onFleet }: Props) {
  return <FleetFields value={fleet} onChange={onFleet} showEnabled />;
}
